<template>
    <v-card>
        <v-form
        ref="form"
        v-model="isFormValid"
        lazy-validation
        @submit.prevent="submit"
        >
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field
                                v-model="selectedItem.name"
                                :rules="formRules.nameRules"
                                label="Nome"
                                required
                                hide-details="auto"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                            <v-text-field
                                v-model="selectedItem.email"
                                :rules="formRules.emailRules"
                                label="Email"
                                required
                                hide-details="auto"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                            <v-text-field
                                v-model="selectedItem.password"
                                :rules="formRules.passwordRules"
                                label="Senha"
                                required
                                hide-details="auto"
                                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show_password ? 'text' : 'password'"
                                @click:append="show_password = !show_password"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                            <v-autocomplete
                                v-model="selectedItem.roles"
                                :items="userRoleOptions"
                                :rules="formRules.userRolesRules"
                                item-text="name"
                                item-value="id"
                                label="Perfil de Acesso"
                                hide-details="auto"
                                multiple
                                clearable
                                chips
                                deletable-chips
                                small-chips
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="#0dc4b8" 
                    text
                    @click="$emit('onClose'); "
                >Cancelar</v-btn>
                <v-btn
                    color="#0dc4b8" 
                    text
                    type="submit"
                    @click="submit"
                    :disabled="isLoading"
                    :loading="isLoading"
                >{{ formButtonText }}</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>


<script>
import { mapMutations } from 'vuex';
import UserRolesService from '../../services/user_roles.service';
import UsersService from '../../services/users.service';

export default {
  name: 'UserForm',
  props: {
    selectedIndex: {
        type: Number,
        required: false,
        default: -1,
    },
    selectedItem: {
        type: Object,
        required: false,
        default: () => ({
            email: null,
            name: null,
            password: null,
            roles: [],
        }),
    },
  },
  data: () => ({
    formRules: {
      emailRules: [
        v => !!v || 'Email é obrigatório',
        v => /.+@.+\..+/.test(v) || 'E-mail inválido',
      ],
      nameRules: [
        v => !!v || 'Nome é obrigatório',
      ],
      passwordRules: [
        v => !!v && v.length >= 6 || 'Senha de no mínimo 6 caracteres é obrigatória',
      ],
      userRolesRules: [
        v => !!v && v.length > 0 || 'Perfil de Acesso é obrigatório',
      ],
    },
    isFormValid: true,
    isLoading: true,
    show_password: false,
    userRoleOptions: [],
  }),
  computed: {
    formButtonText () {
      return this.selectedIndex === -1 ? 'Criar' : 'Editar'
    },
  },
  mounted() {
    this.loadFormOptions();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    loadFormOptions () {
      UserRolesService.get({ sort: 'name' })
        .then(({ data }) => {
          this.userRoleOptions = data.data;
        })
        .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
        .finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    submit () {
      if(this.$refs.form.validate()) {
        this.isLoading = true;
        if (this.selectedIndex > -1) {
          UsersService.put(this.selectedItem, this.selectedItem.id)
            .then(() => {
              this.showSnackbar({ text: "Registro atualizado com sucesso!", color:"success" })
            })
            .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
            .finally(() => setTimeout(() => { this.isLoading = false; this.$emit('onSubmit'); }, 300));
        } else {
          UsersService.store(this.selectedItem)
            .then(() => {
              this.showSnackbar({ text: "Registro criado com sucesso!", color:"success" })
            })
            .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
            .finally(() => setTimeout(() => { this.isLoading = false; this.$emit('onSubmit'); }, 300));
        }
      }
    },
  },
}
</script>
